export const TABS = {
  Analytics: 'analytics',
  Files: 'files',
  Exports: 'exports',
  ProcessingStatus: 'processing-status',
  ContactAnalytics: 'contact-analytics',
  ContactAnalyticsPowerbi: 'contact-analytics-powerbi',
} as const;
